//ASSETS
import otherArticles1 from "assets/img/otherArticles1.jpg";
import otherArticles2 from "assets/img/otherArticles2.jpg";

//MISC

import { DownloadFileType } from "components/Atoms/DownloadFileAtom/DownloadFileAtomModel";
export const content = [
  {
    id: 0,
    title: "7 moduri de a te pregăti pentru un incendiu de locuință",
    content: `**1.** Instalează cel puțin un detector de fum în mod ideal, unul la fiecare etaj și unul în afara fiecărei zone de dormit). Testează-le și înlocuiește-le bateriile când auzi sunetul de baterie descărcată. <br>
        **2.** Învăță-i pe copii cum sună alarmele de fum și ce să facă atunci când aud una.  
        **3.** Asigură-te că toți membrii familiei cunosc două modalități de a ieși din fiecare cameră a casei.  
        **4.** Exersează evacuarea din casă cel puțin de două ori pe an, inclusiv exercițiul de așezare la pământ pentru a evita fumul.  
        **5.** Asigură-te că toată lumea știe unde este punctul de întâlnire sigur.  
        **6.** Asigură-te că toată lumea știe cum să sune la 112.  
        **7.** Învăță-i pe membrii familiei să se oprească, să se așeze la pământ și să se rostogolească dacă hainele lor iau foc.
        `,
  },
  {
    id: 1,
    title: "Deprinde mai multe obiceiuri de siguranță împotriva incendiilor",
    content:
      "Creează și exersează un plan de evacuare cu familia în caz de incendiu Știi cum să ieși din casă pe întuneric în mai puțin de 2 minute? O flacără se poate transforma într-un incendiu în 30 de secunde. Va trebui să suni alarma și să părăsești casa. Fumul nu te va lăsa să respiri corect sau să vezi în jurul tău. Căldura flăcărilor îți poate topi hainele și te poate răni în timp ce respiri. Întreaga casă poate fi cuprinsă de flăcări în mai puțin de 5 minute. Care este planul tău de evacuare? Îl practici de două ori pe an? Consultă aceste ghiduri pentru a dezvolta un plan de evacuare pentru diferite tipuri de locuințe: Dacă locuiești într-o casă unifamilială • Instalează detectoare de fum la fiecare etaj al casei, inclusiv în afara zonelor de dormit și în subsol. Testează lunar și înlocuiește bateriile anual. • Dezvoltă un plan de evacuare cu toți membrii familiei, inclusiv copiii. o Identifică două ieșiri din fiecare cameră. o Asigură-te că ferestrele pot fi deschise cu ușurință. o Alege un loc în care toată lumea să se întâlnească afară. o Ia în considerare plasarea scărilor de evacuare la primul și al doilea etaj pentru a te ajuta să ieși din casă. • Exersează planul până când toată lumea, în special copiii și persoanele cu probleme de mobilitate, din locuință pot ajunge într-un loc sigur în mai puțin de două minute. o Exersează ieșirea afară din casă la nivelul solului în întuneric sau cu ochii închiși. Dacă locuiești într-o casă multifamilială • Instalează detectoare de fum la fiecare etaj al casei, inclusiv în afara zonelor de dormit și în subsol. Testează-le lunar și înlocuiește bateriile anual. • Creează un plan de evacuare cu toți membrii familiei, inclusiv copiii. o Identifică două ieșiri din fiecare cameră. o Asigură-te că ferestrele pot fi deschise cu ușurință. o Alege un loc la exterior în care toată lumea să se întâlnească. o Ia în considerare plasarea scărilor de evacuare la primul și al doilea etaj pentru a vă ajuta să ieșiți. • Exersează planul până când toată lumea, în special copiii și persoanele cu probleme de mobilitate, din familie pot ajunge într-un loc sigur în mai puțin de două minute. o Exersează ieșirea afară din casă la nivelul solului în întuneric sau cu ochii închiși. Dacă locuiești într-un bloc de locuințe • Instalează detectoare de fum la fiecare etaj al casei, inclusiv în afara zonelor de dormit și în subsol. Testează-le lunar și înlocuiește bateriile anual. • Creează un plan de evacuare cu toți membrii familiei, inclusiv copiii. o Identifică două ieșiri din fiecare cameră. o Asigură-te că ferestrele pot fi deschise cu ușurință. o Alege un loc la exterior în care toată lumea să se întâlnească. o Ia în considerare plasarea scărilor de evacuare la primul și al doilea etaj pentru a vă ajuta să ieșiți. • Exersează planul până când toată lumea, în special copiii și persoanele cu probleme de mobilitate din familie pot ajunge într-un loc sigur - fie scările interioare de incendiu ale clădirii, fie un alt loc sigur în clădire - în mai puțin de două minute. • Dacă ești blocat și nu poți ajunge la o scară de ieșire, sună la 112, închide ușile și, dacă este posibil, atârnă un cearșaf alb sau colorat în afara ferestrei, astfel încât pompierii să te poată găsi rapid. • Notă: Asociațiile de proprietari sunt obligate din punct de vedere legal să furnizeze un extinctor la fiecare etaj și să asigure libere rutele de evacuare (vezi Întrebări frecvente pe site-ul Inspectoratului General pentru Situații de Urgență).",
  },
  {
    id: 2,
    title: "7 moduri de a te pregăti pentru un incendiu de locuință",
    content: `**1.** Instalează cel puțin un detector de fum în mod ideal, unul la fiecare etaj și unul în afara fiecărei zone de dormit). Testează-le și înlocuiește-le bateriile când auzi sunetul de baterie descărcată. <br>
        **2.** Învăță-i pe copii cum sună alarmele de fum și ce să facă atunci când aud una.  
        **3.** Asigură-te că toți membrii familiei cunosc două modalități de a ieși din fiecare cameră a casei.  
        **4.** Exersează evacuarea din casă cel puțin de două ori pe an, inclusiv exercițiul de așezare la pământ pentru a evita fumul.  
        **5.** Asigură-te că toată lumea știe unde este punctul de întâlnire sigur.  
        **6.** Asigură-te că toată lumea știe cum să sune la 112.  
        **7.** Învăță-i pe membrii familiei să se oprească, să se așeze la pământ și să se rostogolească dacă hainele lor iau foc.
        `,
  },
  {
    id: 3,
    title: "7 moduri de a te pregăti pentru un incendiu de locuință",
    content: `**1.** Instalează cel puțin un detector de fum în mod ideal, unul la fiecare etaj și unul în afara fiecărei zone de dormit). Testează-le și înlocuiește-le bateriile când auzi sunetul de baterie descărcată. <br>
        **2.** Învăță-i pe copii cum sună alarmele de fum și ce să facă atunci când aud una.  
        **3.** Asigură-te că toți membrii familiei cunosc două modalități de a ieși din fiecare cameră a casei.  
        **4.** Exersează evacuarea din casă cel puțin de două ori pe an, inclusiv exercițiul de așezare la pământ pentru a evita fumul.  
        **5.** Asigură-te că toată lumea știe unde este punctul de întâlnire sigur.  
        **6.** Asigură-te că toată lumea știe cum să sune la 112.  
        **7.** Învăță-i pe membrii familiei să se oprească, să se așeze la pământ și să se rostogolească dacă hainele lor iau foc.
        `,
  },
];

export const otherChapters = [
  {
    id: 0,
    img: otherArticles1,
    title: "Lorem ipsum dolor sit amet, consectetur ",
    date: "11 - 16 aprilie 2024",
    location: "Bucureşti",
  },
  {
    id: 1,
    img: otherArticles2,
    title:
      " Lorem ipsum dolor sit amet, consectetur adipiscing elit Lorem ipsum dolor sit amet, consectetur adipiscing elit Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    date: "11 - 16 aprilie 2024",
    location: "Bucureşti",
  },
  {
    id: 2,
    img: otherArticles2,
    title: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    date: "11 - 16 aprilie 2024",
    location: "Bucureşti",
  },
];

export const download = [
  {
    type: DownloadFileType.Orders,
    title: "Vulputate ut pharetra sit amet…",
    documentType: "Document",
    institution: "Document",
    date: "04.04.2024",
    pdfUrl: "",
  },
  {
    type: DownloadFileType.Orders,
    title: "Vulputate ut pharetra sit amet…",
    documentType: "Document",
    institution: "Document",
    date: "04.04.2024",
    pdfUrl: "",
  },
  {
    type: DownloadFileType.Orders,
    title: "Vulputate ut pharetra sit amet…",
    documentType: "Document",
    institution: "Document",
    date: "04.04.2024",
    pdfUrl: "",
  },
  {
    type: DownloadFileType.Orders,
    title: "Vulputate ut pharetra sit amet…",
    documentType: "Document",
    institution: "Document",
    date: "04.04.2024",
    pdfUrl: "",
  },
  {
    type: DownloadFileType.Orders,
    title: "Vulputate ut pharetra sit amet…",
    documentType: "Document",
    institution: "Document",
    date: "04.04.2024",
    pdfUrl: "",
  },
];
